import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconText2: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="text-2">
      <path
        d="M4 4H12M20 4H12M12 4V20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </CentralIconBase>
  );
};

export default IconText2;
